
import { dataServiceFactory } from '@/definitions/services/data.services';
import SettingsPageLayout from '@/pages/settings/SettingsPageLayout.vue';
import { fromFs } from '@/uikit/attachments';
import { defineComponent } from 'vue';
import {
  LicensePageButtonDownload,
  LicensePageButtonUpdate,
  LicensePageButtonUpload,
  LicensePageHeader,
  LicensePageTab,
  LicensePageTabName,
  LicensePageTabs,
  LicensePageTabView
} from './components';
import { LicenseServiceImpl } from './service';
import { useLicensePageViewModel } from './setup';
import { LICENSE_UPDATE_URL } from './utils';

type LicensePageState = {
  tabName: LicensePageTabName;
};

export default defineComponent({
  name: 'LicensePage',
  components: {
    LicensePageButtonDownload,
    LicensePageButtonUpdate,
    LicensePageButtonUpload,
    LicensePageHeader,
    LicensePageTabs,
    LicensePageTabView,
    SettingsPageLayout
  },
  data: (): LicensePageState => ({
    tabName: 'common'
  }),
  setup: () => {
    const axios = dataServiceFactory.getAxiosInstance();
    return useLicensePageViewModel(new LicenseServiceImpl(axios));
  },
  computed: {
    tabs(): LicensePageTab[] {
      return [
        { name: 'common', label: this.$t('license.common') },
        { name: 'limits', label: this.$t('license.limits') },
        { name: 'intervals', label: this.$t('license.intervals') },
        { name: 'services', label: this.$t('license.services') }
      ];
    },
    enabledTabs(): LicensePageTab[] {
      return this.tabs.filter(this.shouldTabBeEnabled);
    }
  },
  methods: {
    shouldTabBeEnabled(tab: LicensePageTab): boolean {
      let result = false;
      switch (tab.name) {
        case 'intervals':
          result = !!this.licenseUsage?.by_interval.length;
          break;
        case 'limits':
          result = !!this.license?.limits;
          break;
        default:
          result = true;
      }
      return result;
    },
    handleDownloadEvent(): void {
      this.downloadC2V();
    },
    handleUpdateEvent(): void {
      open(LICENSE_UPDATE_URL, '_blank');
    },
    async handleUploadEvent() {
      const [file] = await fromFs('*/*', false);
      await this.importLicense(file);
    }
  }
});
